import { render } from "./Dashboard.layout.vue?vue&type=template&id=1eadb432"
import script from "./Dashboard.layout.vue?vue&type=script&lang=js"
export * from "./Dashboard.layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__